import * as ActionTypes from './actionTypes';
import apiActionCreator from '../../common/service/api/actionCreator';
import {buildErrorMessage} from '../../common/util/errorUtils';
import {getUrlParameters} from '../../common/util/urlParameters';

export const fetchWarrantyCampaigns = (parameters = {}) => (dispatch) => {
  return dispatch(
    apiActionCreator({
      'endpoint': `/campaing/warranties${getUrlParameters(parameters)}`,
      'authenticated': true,
      'types': [
        ActionTypes.FETCHING_WARRANTY_CAMPAIGNS,
        ActionTypes.FETCHED_WARRANTY_CAMPAIGNS,
        [
          ActionTypes.FETCHED_WARRANTY_CAMPAIGNS_FAILED,
          (error) => buildErrorMessage(error),
        ],
      ],
      'microservice': 'part',
      'method': 'GET',
    })
  );
};

export const downloadWarrantyCampaignsExcel = (parameters = {}) =>
  apiActionCreator({
    'endpoint': `/campaing/warranties/excel${getUrlParameters(parameters)}`,
    'authenticated': true,
    'types': [
      ActionTypes.DOWNLOAD_WARRANTY_CAMPAIGNS_EXCEL_REQUEST,
      ActionTypes.DOWNLOAD_WARRANTY_CAMPAIGNS_EXCEL_SUCCESS,
      [
        ActionTypes.DOWNLOAD_WARRANTY_CAMPAIGNS_EXCEL_FAILED,
        (error) => buildErrorMessage(error),
      ],
    ],
    'microservice': 'part',
    'contentType': 'application/json',
    'method': 'GET',
  });

export const clearwarrantyCampaigns = () => {
  return {
    'type': ActionTypes.CLEAR_WARRANTY_CAMPAIGNS,
  };
};

export const clearWarrantyCampaignsExcelFile = () => {
  return {
    'type': ActionTypes.CLEAR_WARRANTY_CAMPAIGNS_EXCEL_FILE,
  };
};
